<template>
  <div v-loading="isLoading" class="container bg-white text-black mx-auto h-full p-10 fs-16">
    <div class="flex justify-start">
      <div class="flex gap-4 items-center cursor-pointer">
        <svg
          @click="goToCircleDetail"
          class="cursor-pointer"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.41406 12.657L12.3641 16.607C12.5417 16.7964 12.6387 17.0475 12.6345 17.3072C12.6303 17.5669 12.5252 17.8148 12.3415 17.9983C12.1578 18.1819 11.9098 18.2868 11.6501 18.2909C11.3905 18.2949 11.1394 18.1977 10.9501 18.02L5.29306 12.364C5.19987 12.2713 5.12592 12.1611 5.07546 12.0398C5.025 11.9185 4.99902 11.7884 4.99902 11.657C4.99902 11.5256 5.025 11.3954 5.07546 11.2741C5.12592 11.1528 5.19987 11.0426 5.29306 10.95L10.9501 5.29296C11.0423 5.19745 11.1526 5.12127 11.2747 5.06886C11.3967 5.01645 11.5279 4.98886 11.6607 4.98771C11.7934 4.98655 11.9251 5.01186 12.048 5.06214C12.1709 5.11242 12.2826 5.18667 12.3765 5.28056C12.4703 5.37446 12.5446 5.48611 12.5949 5.60901C12.6452 5.7319 12.6705 5.86358 12.6693 5.99636C12.6682 6.12914 12.6406 6.26036 12.5882 6.38236C12.5358 6.50437 12.4596 6.61471 12.3641 6.70696L8.41406 10.657H18.0001C18.2653 10.657 18.5196 10.7623 18.7072 10.9499C18.8947 11.1374 19.0001 11.3917 19.0001 11.657C19.0001 11.9222 18.8947 12.1765 18.7072 12.3641C18.5196 12.5516 18.2653 12.657 18.0001 12.657H8.41406Z"
            fill="black"
          />
        </svg>
        <span @click="goToCircleDetail" class="font-bold fs-26">{{ circle.name }}</span>
      </div>
    </div>
    <div class="mt-4">
      <div class="w-full flex flex-col lg:flex-row justify-between gap-4 lg:gap-2">
        <div class="flex-1 flex flex-col gap-2">
          <div class="flex flex-col gap-2">
            <div style="color:#20409b" class="flex-1 fs-20 font-bold">{{sessionData.title }}</div>
            <p class="fs-24 fw-600 max-line-2 txt-pri title mb-0 labels">
              <span
                class="fs-14 text-white"
                :class="getStatus(sessionData.status).class"
              >{{ getStatus(sessionData.status).text }}</span>
            </p>
          </div>
          <div
            v-if="sessionData.circle_schedule_speakers && sessionData.circle_schedule_speakers.length"
            class="flex flex-col gap-2 mb-2"
          >
            <span>{{ $t('circle_feature.lbl_presenter') }}:</span>
            <div class="flex gap-3">
              <div v-for="speaker in sessionData.circle_schedule_speakers" :key="speaker.id">
                <div
                  v-if="speaker.user_speaker"
                  class="flex gap-1 items-center cursor-pointer"
                  @click="goToProfile(speaker.user_speaker)"
                >
                  <div :set="speakerInfo=speaker.user_speaker" style="max-width: 32px">
                    <ImageBox
                      v-if="speakerInfo.avatar"
                      class="avatar avatar-sm avatar-rounded object-cover object-top border"
                      avatar
                      :source="getImageURL(speakerInfo.avatar)"
                      :alt="getMultilangValue(speakerInfo.speaker_multi_language).name || speakerInfo.name"
                    />
                    <span
                      v-if="!speakerInfo||!speakerInfo.avatar"
                      class="avatar avatar-sm avatar-rounded bg-pri text-white"
                    >
                      {{
                      speakerInfo.name.charAt(0) ||
                      speakerInfo.email.charAt(0)
                      }}
                    </span>
                  </div>
                  <span
                    class="font-bold"
                  >{{ getMultilangValue(speakerInfo.speaker_multi_language).name || speakerInfo.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex gap-4">
            <div class="flex gap-2 items-center">
              <svg
                width="16"
                height="16"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 5.5H6.5V3.5C6.5 3.36739 6.44732 3.24021 6.35356 3.14645C6.25979 3.05268 6.13261 3 6 3C5.86739 3 5.74022 3.05268 5.64645 3.14645C5.55268 3.24021 5.5 3.36739 5.5 3.5V6C5.5 6.13261 5.55268 6.25979 5.64645 6.35355C5.74022 6.44732 5.86739 6.5 6 6.5H7.5C7.63261 6.5 7.75979 6.44732 7.85356 6.35355C7.94732 6.25979 8 6.13261 8 6C8 5.86739 7.94732 5.74021 7.85356 5.64645C7.75979 5.55268 7.63261 5.5 7.5 5.5ZM6 1C5.0111 1 4.0444 1.29324 3.22215 1.84265C2.39991 2.39206 1.75904 3.17295 1.3806 4.08658C1.00217 5.00021 0.90315 6.00555 1.09608 6.97545C1.289 7.94536 1.76521 8.83627 2.46447 9.53553C3.16373 10.2348 4.05465 10.711 5.02455 10.9039C5.99446 11.0969 6.99979 10.9978 7.91342 10.6194C8.82705 10.241 9.60794 9.6001 10.1573 8.77785C10.7068 7.95561 11 6.98891 11 6C11 5.34339 10.8707 4.69321 10.6194 4.08658C10.3681 3.47995 9.99983 2.92876 9.53554 2.46447C9.07124 2.00017 8.52005 1.63188 7.91342 1.3806C7.30679 1.12933 6.65661 1 6 1ZM6 10C5.20888 10 4.43552 9.7654 3.77772 9.32588C3.11992 8.88635 2.60723 8.26164 2.30448 7.53073C2.00173 6.79983 1.92252 5.99556 2.07686 5.21964C2.2312 4.44371 2.61216 3.73098 3.17158 3.17157C3.73099 2.61216 4.44372 2.2312 5.21964 2.07686C5.99557 1.92252 6.79983 2.00173 7.53074 2.30448C8.26164 2.60723 8.88635 3.11992 9.32588 3.77772C9.76541 4.43552 10 5.20887 10 6C10 7.06087 9.57858 8.07828 8.82843 8.82843C8.07828 9.57857 7.06087 10 6 10Z"
                  fill="#20419B"
                />
              </svg>
              <span class="flex-1">{{ $t('conference.fm_minutes',{minutes:sessionData.duration}) }}</span>
            </div>
            <div class="flex gap-2 items-center">
              <svg
                class="mb-1"
                width="16"
                height="16"
                viewBox="0 0 10 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 9.5C5.09889 9.5 5.19556 9.47068 5.27779 9.41574C5.36001 9.36079 5.4241 9.2827 5.46194 9.19134C5.49978 9.09998 5.50969 8.99944 5.49039 8.90245C5.4711 8.80546 5.42348 8.71637 5.35355 8.64645C5.28363 8.57652 5.19454 8.5289 5.09755 8.50961C5.00055 8.49031 4.90002 8.50022 4.80866 8.53806C4.7173 8.5759 4.63921 8.63999 4.58427 8.72221C4.52932 8.80444 4.5 8.90111 4.5 9C4.5 9.13261 4.55268 9.25979 4.64645 9.35355C4.74021 9.44732 4.86739 9.5 5 9.5ZM7.5 9.5C7.59889 9.5 7.69556 9.47068 7.77779 9.41574C7.86001 9.36079 7.9241 9.2827 7.96194 9.19134C7.99978 9.09998 8.00969 8.99944 7.99039 8.90245C7.9711 8.80546 7.92348 8.71637 7.85355 8.64645C7.78363 8.57652 7.69454 8.5289 7.59755 8.50961C7.50056 8.49031 7.40002 8.50022 7.30866 8.53806C7.2173 8.5759 7.13921 8.63999 7.08426 8.72221C7.02932 8.80444 7 8.90111 7 9C7 9.13261 7.05268 9.25979 7.14645 9.35355C7.24021 9.44732 7.36739 9.5 7.5 9.5ZM7.5 7.5C7.59889 7.5 7.69556 7.47068 7.77779 7.41573C7.86001 7.36079 7.9241 7.2827 7.96194 7.19134C7.99978 7.09998 8.00969 6.99945 7.99039 6.90245C7.9711 6.80546 7.92348 6.71637 7.85355 6.64645C7.78363 6.57652 7.69454 6.5289 7.59755 6.50961C7.50056 6.49031 7.40002 6.50022 7.30866 6.53806C7.2173 6.5759 7.13921 6.63999 7.08426 6.72221C7.02932 6.80444 7 6.90111 7 7C7 7.13261 7.05268 7.25979 7.14645 7.35355C7.24021 7.44732 7.36739 7.5 7.5 7.5ZM5 7.5C5.09889 7.5 5.19556 7.47068 5.27779 7.41573C5.36001 7.36079 5.4241 7.2827 5.46194 7.19134C5.49978 7.09998 5.50969 6.99945 5.49039 6.90245C5.4711 6.80546 5.42348 6.71637 5.35355 6.64645C5.28363 6.57652 5.19454 6.5289 5.09755 6.50961C5.00055 6.49031 4.90002 6.50022 4.80866 6.53806C4.7173 6.5759 4.63921 6.63999 4.58427 6.72221C4.52932 6.80444 4.5 6.90111 4.5 7C4.5 7.13261 4.55268 7.25979 4.64645 7.35355C4.74021 7.44732 4.86739 7.5 5 7.5ZM8.5 1.5H8V1C8 0.867392 7.94732 0.740215 7.85355 0.646447C7.75979 0.552678 7.63261 0.5 7.5 0.5C7.36739 0.5 7.24021 0.552678 7.14645 0.646447C7.05268 0.740215 7 0.867392 7 1V1.5H3V1C3 0.867392 2.94732 0.740215 2.85355 0.646447C2.75979 0.552678 2.63261 0.5 2.5 0.5C2.36739 0.5 2.24021 0.552678 2.14645 0.646447C2.05268 0.740215 2 0.867392 2 1V1.5H1.5C1.10218 1.5 0.720644 1.65804 0.43934 1.93934C0.158035 2.22064 0 2.60218 0 3V10C0 10.3978 0.158035 10.7794 0.43934 11.0607C0.720644 11.342 1.10218 11.5 1.5 11.5H8.5C8.89782 11.5 9.27936 11.342 9.56066 11.0607C9.84196 10.7794 10 10.3978 10 10V3C10 2.60218 9.84196 2.22064 9.56066 1.93934C9.27936 1.65804 8.89782 1.5 8.5 1.5ZM9 10C9 10.1326 8.94732 10.2598 8.85355 10.3536C8.75979 10.4473 8.63261 10.5 8.5 10.5H1.5C1.36739 10.5 1.24021 10.4473 1.14645 10.3536C1.05268 10.2598 1 10.1326 1 10V5.5H9V10ZM9 4.5H1V3C1 2.86739 1.05268 2.74021 1.14645 2.64645C1.24021 2.55268 1.36739 2.5 1.5 2.5H2V3C2 3.13261 2.05268 3.25979 2.14645 3.35355C2.24021 3.44732 2.36739 3.5 2.5 3.5C2.63261 3.5 2.75979 3.44732 2.85355 3.35355C2.94732 3.25979 3 3.13261 3 3V2.5H7V3C7 3.13261 7.05268 3.25979 7.14645 3.35355C7.24021 3.44732 7.36739 3.5 7.5 3.5C7.63261 3.5 7.75979 3.44732 7.85355 3.35355C7.94732 3.25979 8 3.13261 8 3V2.5H8.5C8.63261 2.5 8.75979 2.55268 8.85355 2.64645C8.94732 2.74021 9 2.86739 9 3V4.5ZM2.5 7.5C2.59889 7.5 2.69556 7.47068 2.77779 7.41573C2.86001 7.36079 2.9241 7.2827 2.96194 7.19134C2.99978 7.09998 3.00969 6.99945 2.99039 6.90245C2.9711 6.80546 2.92348 6.71637 2.85355 6.64645C2.78363 6.57652 2.69454 6.5289 2.59755 6.50961C2.50055 6.49031 2.40002 6.50022 2.30866 6.53806C2.2173 6.5759 2.13921 6.63999 2.08427 6.72221C2.02932 6.80444 2 6.90111 2 7C2 7.13261 2.05268 7.25979 2.14645 7.35355C2.24021 7.44732 2.36739 7.5 2.5 7.5ZM2.5 9.5C2.59889 9.5 2.69556 9.47068 2.77779 9.41574C2.86001 9.36079 2.9241 9.2827 2.96194 9.19134C2.99978 9.09998 3.00969 8.99944 2.99039 8.90245C2.9711 8.80546 2.92348 8.71637 2.85355 8.64645C2.78363 8.57652 2.69454 8.5289 2.59755 8.50961C2.50055 8.49031 2.40002 8.50022 2.30866 8.53806C2.2173 8.5759 2.13921 8.63999 2.08427 8.72221C2.02932 8.80444 2 8.90111 2 9C2 9.13261 2.05268 9.25979 2.14645 9.35355C2.24021 9.44732 2.36739 9.5 2.5 9.5Z"
                  fill="#20419B"
                />
              </svg>
              <span class="flex-1">{{ getDuration() }}</span>
            </div>
          </div>
        </div>
        <div>
          <div
            v-if=" (isMember || isAdmin) &&
                circle &&
                (circle.type === CIRCLE_TYPE.LIVE || circle.live_room_id)
              "
            class="open-chat-att"
            @click="goToStream"
          >
            <div class="d-flex align-items-center">
              <img
                class="mr-2"
                :src="liveStream"
                :alt="circle && circle.name"
                width="32"
                height="32"
              />
              <div>
                <span
                  class="inline-block livestream-redot mb-0"
                  v-if="circle && circle.is_live_stream === 2"
                >{{ $t('lbl_live') }}</span>
                <span class="block txt-black fs-16 fw-500">
                  {{
                  (user_100ms_role === "presenter" || user_100ms_role === "broadcaster") ? $t("circle_feature.lbl_circle_live") : circle && circle.is_live_stream === 2 ? $t("circle_feature.lbl_circle_live_watch_now") : $t("circle_feature.lbl_circle_live_watch")
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="sessionData.file_schedule&&sessionData.file_schedule.length" class="mt-4">
        <div
          v-for="file in sessionData.file_schedule"
          :key="file.id"
          class="flex mb-3 gap-2 items-center"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 10H10C10.2652 10 10.5196 9.89464 10.7071 9.70711C10.8946 9.51957 11 9.26522 11 9C11 8.73478 10.8946 8.48043 10.7071 8.29289C10.5196 8.10536 10.2652 8 10 8H9C8.73478 8 8.48043 8.10536 8.29289 8.29289C8.10536 8.48043 8 8.73478 8 9C8 9.26522 8.10536 9.51957 8.29289 9.70711C8.48043 9.89464 8.73478 10 9 10ZM9 12C8.73478 12 8.48043 12.1054 8.29289 12.2929C8.10536 12.4804 8 12.7348 8 13C8 13.2652 8.10536 13.5196 8.29289 13.7071C8.48043 13.8946 8.73478 14 9 14H15C15.2652 14 15.5196 13.8946 15.7071 13.7071C15.8946 13.5196 16 13.2652 16 13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12H9ZM20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11C13.4402 2.10576 13.4099 2.10576 13.38 2.11C13.2784 2.05174 13.1662 2.01434 13.05 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H15C14.7348 8 14.4804 7.89464 14.2929 7.70711C14.1054 7.51957 14 7.26522 14 7V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V7C12 7.79565 12.3161 8.55871 12.8787 9.12132C13.4413 9.68393 14.2044 10 15 10H18V19ZM15 16H9C8.73478 16 8.48043 16.1054 8.29289 16.2929C8.10536 16.4804 8 16.7348 8 17C8 17.2652 8.10536 17.5196 8.29289 17.7071C8.48043 17.8946 8.73478 18 9 18H15C15.2652 18 15.5196 17.8946 15.7071 17.7071C15.8946 17.5196 16 17.2652 16 17C16 16.7348 15.8946 16.4804 15.7071 16.2929C15.5196 16.1054 15.2652 16 15 16Z"
              fill="#20409B"
            />
          </svg>
          <a :href="file.url" target="_blank" class="cs-link">{{ file.name }}</a>
        </div>
      </div>
      <div class="flex flex-col gap-2 mt-4">
        <div class="font-bold fs-18">{{ $t('conference.lbl_summary') }}</div>
        <span class="ml-3">{{ sessionData.content||'' }}</span>
      </div>
      <div class="mt-4">
        <div v-if="isAdmin" class="font-bold fs-18 mb-2">{{ $t('lbl_video_management') }}</div>

        <el-input
          v-if="isAdmin"
          class="required"
          :placeholder="$t('lbl_enter_link_video')"
          v-model="video_url"
        >
          <template slot="append">
            <span
              class="cursor-pointer text-blue-900 font-bold"
              @click="handleUpdateVideo"
            >{{ $t('lbl_save_video') }}</span>
          </template>
        </el-input>

        <div
          class="col-12 mt-2 mx-auto"
          v-if="sessionData.session_recording_url && (isAdmin || isPublicShowVideo)"
        >
          <div class="flex items-center mb-2 w-fit">
            <div class="mr-2">
              <svg
                viewBox="0 0 24 24"
                width="24"
                height="24"
                stroke="currentColor"
                stroke-width="2"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="css-i6dzq1"
              >
                <path
                  d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
                />
                <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" />
              </svg>
            </div>
            <div class="fs-14 fw-600">Video</div>
            <div v-if="isAdmin" class="ml-4">
              <button
                class="flex items-end btn btn--bg-primary text-white"
                :class="isPublicShowVideo && !isSubmittingPublicShowVideo ? 'bg-danger' : 'bg-pri'"
                @click.stop="toggleIsPublicShowVideo"
                :disabled="isSubmittingPublicShowVideo"
              >
                <template v-if="isPublicShowVideo && !isSubmittingPublicShowVideo">
                  <i class="el-icon-circle-close fs-18 mr-2" />
                  <span>{{ $t('lbl_hide_video') }}</span>
                </template>
                <template v-else-if="!isPublicShowVideo && !isSubmittingPublicShowVideo">
                  <i class="el-icon-circle-check fs-18 mr-2" />
                  <span>{{ $t('lbl_show_video') }}</span>
                </template>
                <template v-else>
                  <i class="el-icon-loading fs-18 mr-2" />
                  <span>{{ $t('lbl_process_video') }}</span>
                </template>
              </button>
            </div>
          </div>
          <div class="mb-3" :class="{'max-w-5xl': !zoomVideo}">
            <video-player
              class="video-player-box"
              ref="videoPlayer"
              :options="playerOptions"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @ended="onPlayerEnded($event)"
              @loadeddata="onPlayerLoadeddata($event)"
              @waiting="onPlayerWaiting($event)"
              @playing="onPlayerPlaying($event)"
              @timeupdate="onPlayerTimeupdate($event)"
              @canplay="onPlayerCanplay($event)"
              @canplaythrough="onPlayerCanplaythrough($event)"
              @statechanged="playerStateChanged($event)"
              @ready="playerReadied"
            ></video-player>
            <div class="bg-gray-50 flex items-center">
              <div></div>
              <div
                class="bg-gray-100 hover:bg-gray-200 ml-auto cursor-pointer p-2 border transition-all duration-200"
                @click.stop="toggleZoomVideo"
              >
                <span class="inline-block w-6 h-6 mr-2">
                  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="path-1-inside-1_1_2" fill="white">
                      <path
                        d="M0 41C0 38.7909 1.79086 37 4 37H38V77H4C1.79086 77 0 75.2091 0 73V41Z"
                      />
                    </mask>
                    <path
                      d="M0 41C0 38.7909 1.79086 37 4 37H38V77H4C1.79086 77 0 75.2091 0 73V41Z"
                      stroke="currentColor"
                      stroke-width="16"
                      mask="url(#path-1-inside-1_1_2)"
                    />
                    <mask id="path-2-inside-2_1_2" fill="white">
                      <path
                        d="M30 26C30 23.7909 31.7909 22 34 22H96C98.2091 22 100 23.7909 100 26V73C100 75.2091 98.2091 77 96 77H30V26Z"
                      />
                    </mask>
                    <path
                      d="M30 26C30 23.7909 31.7909 22 34 22H96C98.2091 22 100 23.7909 100 26V73C100 75.2091 98.2091 77 96 77H30V26Z"
                      stroke="currentColor"
                      stroke-width="16"
                      mask="url(#path-2-inside-2_1_2)"
                    />
                  </svg>
                </span>
                <span v-if="!zoomVideo">{{ $t('lbl_cinema_mode') }}</span>
                <span v-else>{{ $t('lbl_default_mode') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'videojs-resolution-switcher'
import 'videojs-resolution-switcher/lib/videojs-resolution-switcher.css'
import 'videojs-watermark'

import { LANGUAGE_CODES_FOR_DISEASE } from '@/lang'
import appUtils from '@/utils/appUtils'
import ImageBox from '@/components/Common/Image.vue'
import { CIRCLE_TYPE } from '../../utils/constants'
import liveStream from '@/assets/images/livestream.png'
import { videoPlayer } from 'vue-video-player'

export default {
  name: 'CircleSessionDetail',
  components: { ImageBox, videoPlayer },
  data () {
    return {
      sessionData: {},
      isLoading: false,
      user_id: '',
      user_100ms_role: 'guest',
      selectedFeature: 'livestream',
      circle: {},
      appUtils,
      CIRCLE_TYPE,
      liveStream,
      circle_member: {},
      video_url: '',
      zoomVideo: false,
      playerSources: [],
      playerOptions: {
        muted: false,
        language: this.$lang,
        plugins: {
          videoJsResolutionSwitcher: {
            ui: true,
            default: 3,
            dynamicLabel: true
          }
        },
        playbackRate: 1,
        playbackRates: [0.7, 1.0, 1.5, 2.0]
      },
      isSubmittingPublicShowVideo: false,
      isPublicShowVideo: false
    }
  },
  watch: {
    $route: {
      deep: true,
      handler () {
        this.getSessionDetail()
      }
    }
  },
  async created () {
    this.user_id = appUtils.getLocalUser().id
    await this.getSessionDetail()
    // await this.showCircle()
    // await this.get100msRole()
  },
  computed: {
    lang () {
      return LANGUAGE_CODES_FOR_DISEASE[this.$lang.toUpperCase()]
    },
    isMember () {
      return !!this.circle_member && this.circle_member.status === 2
    },
    isAdmin () {
      return (
        (!!this.isMember && this.circle_member.role === 1) ||
        this.circle?.created_by === this.user_id
      )
    },
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    async getSessionDetail () {
      if (!this.$route.params?.id) {
        return
      }

      try {
        this.isLoading = true
        const response = await this.$rf
          .getRequest('CommonRequest')
          .getLiveStreamScheduleDetail(this.$route.params?.id)
        this.sessionData = response.data || {}
        this.circle = response.data?.circle_info || {}

        this.isPublicShowVideo = response?.data?.is_show_url_record === 2
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    getDataLang () {
      const langValue = this.lang
      const langData =
        this.sessionData?.pape_multilanguage?.find(
          item => item?.lang === langValue
        ) || {}
      return langData
    },
    getImageURL (avatar) {
      if (avatar.includes('https')) return avatar
      return appUtils.getImageURL(avatar)
    },
    goToProfile (data) {
      const doctorId = data?.doctor_infor?.id
      if (!doctorId) return
      this.$router
        .push({ name: 'DoctorProfile', params: { id: doctorId } })
        .catch(() => {})
    },
    displayDuration (totalMinutes) {
      return this.$t('conference.fm_minutes', { minutes: totalMinutes })
    },
    getDuration () {
      return window
        .moment(this.sessionData.schedule_date)
        .format('DD/MM/YYYY HH:mm')
    },
    async get100msRole () {
      const circle_id = Number(this.circle?.id)
      await this.$rf
        .getRequest('DoctorRequest')
        .checkMyRoleConferenceRoom({
          circle_id,
          user_id: this.user_id
        })
        .then(res => {
          this.user_100ms_role =
            res.data?.one_hundred_ms_role ||
            JSON.stringify({
              conference: 'guest',
              livestream: 'viewer'
            })
        })
        .catch(e => {
          console.log(e)
          this.$toast.open({
            message: e,
            type: 'error'
          })
        })
    },

    async showCircle () {
      let self = this
      if (!this.$route.params.id) return
      let r = await this.$rf
        .getRequest('DoctorRequest')
        .showCircle(this.$route.params.id)
        .then(r => {
          self.circle = { ...r.data }

          return r
        })
        .catch(e => {
          console.log(e)
          self.$toast.open({
            message: this.$t('circle_feature.lbl_permission_msg'),
            type: 'warning'
          })
          self.$router.push({ name: 'WorkspaceConference' }).catch(() => {})
          return false
        })
      return r?.data
    },
    getStatus (status) {
      switch (status) {
        case 1:
          return {
            text: this.$t('circle_feature.lbl_draft_schedule'),
            class: 'draft'
          }
        case 2:
          return {
            text: this.$t('circle_feature.lbl_public_schedule'),
            class: 'public'
          }
        case 3:
          return {
            text: this.$t('circle_feature.lbl_live_now'),
            class: 'ongoing'
          }
        default:
          return {
            text: this.$t('circle_feature.lbl_draft_schedule'),
            class: 'draft'
          }
      }
    },
    goToCircleDetail () {
      this.$router.go(-1)
    },
    getMultilangValue (data) {
      return data?.find(item => (item?.Lang || item?.lang) === this.lang) || {}
    },

    async goToStream () {
      if (!this.circle.live_room_id) {
        alert(this.$t('circle_feature.lbl_live_circle_not_exist'))
        return
      }

      const { id, live_room_id } = this.circle
      await this.get100msRole().then(() => {
        let token = appUtils.getLocalToken()
        // let dm = 'http://localhost:3000'
        let dm = ''
        if (process.env.NODE_ENV === 'development') {
          dm = 'https://dev.live.hodo.app'
        } else {
          dm = 'https://live.hodo.app'
        }

        const roleObj = appUtils.isJSON(this.user_100ms_role)
          ? JSON.parse(this.user_100ms_role)
          : {
            [this.selectedFeature]: this.user_100ms_role
          }
        const role = roleObj[this.selectedFeature]
        const routeRaw = `${dm}/redirect.html?token=${token}&room_id=${live_room_id}&circle_id=${id}&type=streaming&role=${role ||
          'viewer'}&lang=${this.$lang}`

        console.log(routeRaw)

        // let linkElement = document.createElement('a')
        // const linkId = `conf_${live_room_id}`
        // linkElement.id = linkId
        // linkElement.href = routeRaw
        // window.document.body.appendChild(linkElement)
        //
        // const linkEl = document.getElementById(linkId)
        // linkEl.setAttribute('rel', 'noopener noreferrer')
        // !appUtils.checkIsMobile() && linkEl.setAttribute('target', '_blank')
        // linkEl.click()
        // linkEl.remove()

        setTimeout(() => {
          window.open(
            routeRaw,
            '_blank',
            'noopener noreferrer'
          )
        })

        // window.open(routeRaw, '_blank')
      })
    },
    async getMember () {
      const self = this
      await this.$rf
        .getRequest('DoctorRequest')
        .getMemberByUserId(
          this.$route.params.id,
          appUtils.getLocalUser().id,
          null,
          false
        )
        .then(async r => {
          self.circle_member = r.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    async handleUpdateVideo () {
      try {
        const sessionId = this.$route.params?.id

        if (!sessionId) return

        if (!this.video_url) {
          this.$toast.open({
            message: this.$t('msg_enter_link_video'),
            type: 'warning'
          })

          return
        }

        const params = {
          circle_id: this.circle.id,
          session_recording_url: this.video_url
        }
        this.isLoading = true
        await this.$rf
          .getRequest('CommonRequest')
          .editLivestreamSchedule(sessionId, params)

        this.$toast.open({
          message: this.$t('lbl_save_video_success'),
          type: 'success'
        })

        await this.getSessionDetail()

        this.playerSources = [
          {
            src: this.sessionData.session_recording_url,
            type: 'video/mp4',
            label: 'HD'
          }
        ]
        this.$refs.videoPlayer.player.updateSrc(this.playerSources)
      } catch (error) {
        console.log(error)
        this.$toast.open({
          message: this.$t('lbl_save_video_fail'),
          type: 'error'
        })
      } finally {
        this.isLoading = false
      }
    },
    onPlayerPlay (player) {},
    onPlayerPause (player) {},
    onPlayerEnded (player) {},
    onPlayerTimeupdate (player) {},
    onPlayerLoadeddata (player) {},
    onPlayerWaiting (player) {},
    onPlayerPlaying (player) {},
    onPlayerCanplay (player) {},
    onPlayerCanplaythrough (player) {},
    playerStateChanged (playerCurrentState) {},
    playerReadied (player) {
      if (player.watermark && this.sessionData.session_recording_url) {
        player.watermark({
          image: this.circle?.logo || 'https://hodo.app/hodologo_256x256.png'
        })
      }
      if (player.updateSrc && this.sessionData.session_recording_url) {
        this.playerSources = [
          {
            src: this.sessionData.session_recording_url,
            type: 'video/mp4',
            label: 'HD',
            res: 720
          }
        ]
        player.updateSrc(this.playerSources)
        player.on('resolutionchange', function () {
          console.info('Source changed to %s', player.src())
        })
      }
    },
    toggleZoomVideo () {
      this.zoomVideo = !this.zoomVideo
    },
    async toggleIsPublicShowVideo () {
      const sessionId = this.$route.params?.id

      if (!sessionId) return

      try {
        this.isSubmittingPublicShowVideo = true
        this.isPublicShowVideo = !this.isPublicShowVideo
        const params = {
          circle_id: this.circle.id,
          is_show_url_record: this.sessionData?.is_show_url_record === 2 ? 1 : 2
        }
        this.isLoading = true
        const res = await this.$rf
          .getRequest('CommonRequest')
          .editLivestreamSchedule(sessionId, params)

        if (!res?.data) {
          this.isPublicShowVideo = !this.isPublicShowVideo
          return
        }

        this.isPublicShowVideo = res?.data?.is_show_url_record === 2
      } catch (error) {
        console.log(error)
        this.$message({
          type: 'error',
          message: this.$t(`msg_have_error_when_update`)
        })
        this.isPublicShowVideo = !this.isPublicShowVideo
      } finally {
        this.isSubmittingPublicShowVideo = false
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cs-live {
  border: 3px solid #f04438;
  border-radius: 16px;
  padding: 6px;
  max-width: 140px;
  color: #f04438;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cs-link {
  text-decoration: underline;
  color: #20409b;
}

.title {
  &.labels {
    line-height: 21px;
  }
  span {
    display: inline-block;
    text-wrap: nowrap;
    border-radius: 15px;
    padding: 2px 10px;
  }
  .draft {
    background-color: rgb(0, 195, 255);
  }
  .public {
    background-color: #00b135;
  }
  .ongoing {
    background-color: red;
  }
}

pre {
  background: transparent;
  border: unset;
}

.open-chat-att {
  padding: 16px;
  display: flex;
  align-items: center;
  background-color: #fafafa;
  width: 100%;
  border-radius: 10px;
  cursor: pointer;
  margin-bottom: 16px;
  position: relative;
  transition: all 0.3s ease;
  max-width: 200px;

  &:hover {
    background-color: #eff4ff;
  }
}

::v-deep {
  .el-input__inner {
    border: 1px solid #dcdfe6 !important;
    border-radius: 0 !important;
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
  }

  .video-player-box {
    position: relative;

    &::before {
      content: "";
      display: block;
      padding-top: percentage(9/16);
    }
    .video-js {
      position: absolute;
      top: 0;
      left: 0;
      width: 100% !important;
      height: 100% !important;
    }

    @mixin transition($args...) {
      -webkit-transition: $args;
      -moz-transition: $args;
      -ms-transition: $args;
      -o-transition: $args;
      transition: $args;
    }

    // Sass for videojs-watermark
    .video-js {
      &.vjs-watermark {
        display: block;
      }
      .vjs-watermark-content {
        opacity: 0.99;
        position: absolute;
        padding: 16px 16px 0 0;
        width: 4rem;
        height: 4rem;
        @include transition(visibility 1s, opacity 1s);
      }

      // pre-defined positions
      .vjs-watermark-top-right {
        right: 0;
        top: 0;
      }
      .vjs-watermark-top-left {
        left: 0;
        top: 0;
      }
      // bottom set to 30px to account for controlbar
      .vjs-watermark-bottom-right {
        right: 0;
        bottom: 30px;
      }
      .vjs-watermark-bottom-left {
        left: 0;
        bottom: 30px;
      }

      //fade out when the user is not active and the video is playing.
      &.vjs-user-inactive.vjs-playing .vjs-watermark-fade {
        opacity: 0;
      }
    }
  }
}
</style>
